import { render } from "./AdminAgentesView.vue?vue&type=template&id=ebfe6fee&scoped=true"
import script from "./AdminAgentesView.vue?vue&type=script&lang=js"
export * from "./AdminAgentesView.vue?vue&type=script&lang=js"

import "./AdminAgentesView.vue?vue&type=style&index=0&id=ebfe6fee&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebfe6fee"]])

export default __exports__